export function waitForElemWithAttr(selector, targetString) {
    return new Promise(resolve => {
      const checkHref = () => {
        const element = document.querySelector(selector);
        if (element && element.getAttribute('href') && element.getAttribute('href').includes(targetString)) {
          resolve(element);
        }
      };
  
      checkHref(); // Check initially
  
      const observer = new MutationObserver(mutations => {
        checkHref(); // Check on mutations
      });
  
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  }
  